import {
  AccountSetupApi,
  AuthenticationApi,
  BlobApi,
  BusinessUnitsApi,
  CategoriesApi,
  CompaniesApi,
  Configuration,
  ExpensesApi,
  ImportApi,
  InvoicesApi,
  MetadataApi,
  OrderLabelsApi,
  OrdersApi,
  OrganizationsAdminApi,
  OrganizationUsersApi,
  PasswordApi,
  RoleManagementApi,
  SearchApi,
  UsersAdminApi,
  UsersApi,
  WorkbooksApi,
} from "@/src/generated/api/src";
import { createClientApiConfiguration } from "./createClientApiConfiguration";

export default class ApiWrapper {
  private _configuration: Configuration;
  private _authenticationApi?: AuthenticationApi;
  private _accountSetupApi?: AccountSetupApi;
  private _blobApi?: BlobApi;
  private _businessUnitsApi?: BusinessUnitsApi;
  private _categoriesApi?: CategoriesApi;
  private _companiesApi?: CompaniesApi;
  private _expensesApi?: ExpensesApi;
  private _importApi?: ImportApi;
  private _invoicesApi?: InvoicesApi;
  private _metadataApi?: MetadataApi;
  private _orderLabelsApi?: OrderLabelsApi;
  private _ordersApi?: OrdersApi;
  private _organizationsAdminApi?: OrganizationsAdminApi;
  private _organizationUsersApi?: OrganizationUsersApi;
  private _passwordApi?: PasswordApi;
  private _roleManagementApi?: RoleManagementApi;
  private _searchApi?: SearchApi;
  private _usersApi?: UsersApi;
  private _usersAdminApi?: UsersAdminApi;
  private _workbooksApi?: WorkbooksApi;

  get authenticationApi(): AuthenticationApi {
    if (!this._authenticationApi) {
      this._authenticationApi = new AuthenticationApi(this._configuration);
    }
    return this._authenticationApi;
  }

  get accountSetupApi(): AccountSetupApi {
    if (!this._accountSetupApi) {
      this._accountSetupApi = new AccountSetupApi(this._configuration);
    }
    return this._accountSetupApi;
  }

  get blobApi(): BlobApi {
    if (!this._blobApi) {
      this._blobApi = new BlobApi(this._configuration);
    }
    return this._blobApi;
  }

  get businessUnitsApi(): BusinessUnitsApi {
    if (!this._businessUnitsApi) {
      this._businessUnitsApi = new BusinessUnitsApi(this._configuration);
    }
    return this._businessUnitsApi;
  }

  get categoriesApi(): CategoriesApi {
    if (!this._categoriesApi) {
      this._categoriesApi = new CategoriesApi(this._configuration);
    }
    return this._categoriesApi;
  }

  get companiesApi(): CompaniesApi {
    if (!this._companiesApi) {
      this._companiesApi = new CompaniesApi(this._configuration);
    }
    return this._companiesApi;
  }

  get expensesApi(): ExpensesApi {
    if (!this._expensesApi) {
      this._expensesApi = new ExpensesApi(this._configuration);
    }
    return this._expensesApi;
  }

  get importApi(): ImportApi {
    if (!this._importApi) {
      this._importApi = new ImportApi(this._configuration);
    }
    return this._importApi;
  }

  get invoicesApi(): InvoicesApi {
    if (!this._invoicesApi) {
      this._invoicesApi = new InvoicesApi(this._configuration);
    }
    return this._invoicesApi;
  }

  get metadataApi(): MetadataApi {
    if (!this._metadataApi) {
      this._metadataApi = new MetadataApi(this._configuration);
    }
    return this._metadataApi;
  }

  get orderLabelsApi(): OrderLabelsApi {
    if (!this._orderLabelsApi) {
      this._orderLabelsApi = new OrderLabelsApi(this._configuration);
    }
    return this._orderLabelsApi;
  }

  get ordersApi(): OrdersApi {
    if (!this._ordersApi) {
      this._ordersApi = new OrdersApi(this._configuration);
    }
    return this._ordersApi;
  }

  get organizationsAdminApi(): OrganizationsAdminApi {
    if (!this._organizationsAdminApi) {
      this._organizationsAdminApi = new OrganizationsAdminApi(this._configuration);
    }
    return this._organizationsAdminApi;
  }

  get organizationUsersApi(): OrganizationUsersApi {
    if (!this._organizationUsersApi) {
      this._organizationUsersApi = new OrganizationUsersApi(this._configuration);
    }
    return this._organizationUsersApi;
  }

  get passwordApi(): PasswordApi {
    if (!this._passwordApi) {
      this._passwordApi = new PasswordApi(this._configuration);
    }
    return this._passwordApi;
  }

  get roleManagementApi(): RoleManagementApi {
    if (!this._roleManagementApi) {
      this._roleManagementApi = new RoleManagementApi(this._configuration);
    }
    return this._roleManagementApi;
  }

  get searchApi(): SearchApi {
    if (!this._searchApi) {
      this._searchApi = new SearchApi(this._configuration);
    }
    return this._searchApi;
  }

  get usersApi(): UsersApi {
    if (!this._usersApi) {
      this._usersApi = new UsersApi(this._configuration);
    }
    return this._usersApi;
  }

  get usersAdminApi(): UsersAdminApi {
    if (!this._usersAdminApi) {
      this._usersAdminApi = new UsersAdminApi(this._configuration);
    }
    return this._usersAdminApi;
  }

  get workbooksApi(): WorkbooksApi {
    if (!this._workbooksApi) {
      this._workbooksApi = new WorkbooksApi(this._configuration);
    }
    return this._workbooksApi;
  }

  public constructor(configuration?: Configuration) {
    this._configuration = configuration ?? createClientApiConfiguration();
  }
}

const ClientApiWrapper = new ApiWrapper();
export const {
  authenticationApi,
  accountSetupApi,
  blobApi,
  businessUnitsApi,
  categoriesApi,
  companiesApi,
  expensesApi,
  importApi,
  invoicesApi,
  metadataApi,
  orderLabelsApi,
  ordersApi,
  organizationsAdminApi,
  organizationUsersApi,
  passwordApi,
  roleManagementApi,
  searchApi,
  usersApi,
  usersAdminApi,
  workbooksApi,
} = ClientApiWrapper;

// Export types for use throughout the application
export * from "@/src/generated/api/src/index";
